import React from 'react';
import { Tooltip } from 'antd';
// import { createLanguageFilters } from '@utils/supportedLanguages';
// import LanguageIcon from '@components/LanguageIcon';
import PublishedStatusIcon from '@components/PublishedStatusIcon';
import './style.less';

export default (t, defaultFilteredValue, contentTypeTranslationKey) => [
  // {
  //   title: t('cards:MessagesList.columns.language.title'),
  //   dataIndex: 'language',
  //   defaultFilteredValue: defaultFilteredValue.language || [],
  //   key: 'language',
  //   render: language => <LanguageIcon language={language} />,
  //   width: 150,
  //   sorter: (a, b) => a.language > b.language,
  //   filters: createLanguageFilters(t),
  //   onFilter: (value, record) => record.language === value,
  // },
  {
    title: t(`cards:MessagesList.columns.${contentTypeTranslationKey}.title`),
    dataIndex: 'name',
    key: 'name',
    ellipsis: true,
    sorter: (a, b) => a.name.localeCompare(b.name),
  },
  {
    title: t('cards:MessagesList.columns.published.title'),
    dataIndex: 'published',
    defaultFilteredValue: defaultFilteredValue.published || [],
    key: 'published',
    render: published => (
      <Tooltip
        placement="bottom"
        title={
          published
            ? t('cards:MessagesList.columns.published.published')
            : t('cards:MessagesList.columns.published.unpublished')
        }
      >
        <PublishedStatusIcon published={published} />
      </Tooltip>
    ),
    width: 150,
    sorter: ({ published: a }, { published: b }) => a - b,
    filters: [
      {
        text: t('cards:MessagesList.columns.published.published'),
        value: true,
      },
      {
        text: t('cards:MessagesList.columns.published.unpublished'),
        value: false,
      },
    ],
    onFilter: (value, record) => record.published === value,
  },
];
